import { Injectable } from '@angular/core';
import { HttpServices } from '../../../shared/services/http-service.service';

@Injectable({ providedIn: 'root' })

export class LookupService {
  constructor(private http: HttpServices) { }

  public getCountries() {
    return this.http.get("Lookups/GetCountries");
  }
  public getCirculars() {
    return this.http.get("Lookups/GetCirculars");
  }
  public GetRegionsByCircularID(circularsId){
    return this.http.get("Lookups/GetRegionsByCircularID?circularsId="+ circularsId);

  }
  public GetRegionsByOriginID(originID){
    return this.http.get("Lookups/GetRegionsByOriginID?originID="+ originID);

  }


  public GetCircularsByIds(ids) {
    return this.http.post("Lookups/GetCircularsByIds", ids);
  }

  public GetFilteredCirculars(ids,SailingDate,ETA) {
    return this.http.get("Lookups/GetFilteredCirculars?ids="+ids+"&SailingDate="+SailingDate+"&ETA="+ETA);
  }



  public getRegistrationType() {
    return this.http.get("Lookups/GetRegistrationType");
  }

  public getPortalUserType() {
    return this.http.get("Lookups/GetUserType");
  }

  public getClassificationSociety() {
    return this.http.get("Lookups/GetClassificationSociety");
  }

  public getFlags() {
    return this.http.get("Lookups/GetFlags");
  }

  public GetJobTypes() {
    return this.http.get("Lookups/GetJobTypes");
  }

  public GetSalvageAnchorageAreas() {
    return this.http.get("Lookups/GetSalvageAnchorageAreas");
  }

  public GetUnitTypes() {
    return this.http.get("Lookups/GetTypeOFUnit");
  }

  public getVesselTypes() {
    return this.http.get("Lookups/GetVesselTypes");
  }

  public getCircularsVesselTypes() {
    return this.http.get("Lookups/GetCircularsVesselTypes");
  }

  public getQualityServices() {
    return this.http.get("Lookups/GetQualityService");
  }

  public getAcceptenceCriteria() {
    return this.http.get("Lookups/GetAcceptenceCriteria");
  }

  public getEquipmentTypes() {
    return this.http.get("Lookups/GetMachineTypes");
  }

  public getMagentTypes() {
    return this.http.get("Lookups/GetMagentTypes");
  }

  public getMaterialForm() {
    return this.http.get("Lookups/GetMaterialForm");
  }

  public getFilmType() {
    return this.http.get("Lookups/GetFilmType");
  }

  public getCurrencies() {
    return this.http.get("Lookups/GetCurrencies");
  }

  public GetFibberglassServices() {
    return this.http.get("Lookups/GetFibberglassServices");
  }

  public GetBoatTypes() {
    return this.http.get("Lookups/GetBoatTypes");
  }

  public GetFibberglassExtraDocumentations() {
    return this.http.get("Lookups/GetFibberglassExtraDocumentations");
  }

  public GetCommunicationsNavigations() {
    return this.http.get("Lookups/GetCommunicationsNavigations");
  }

  public GetLightingLoads() {
    return this.http.get("Lookups/GetLightingLoads");
  }

  public GetVoltsDC380On220() {
    return this.http.get("Lookups/GetVoltsDC380On220");
  }

  public GetYachtSafeties() {
    return this.http.get("Lookups/GetYachtSafeties");
  }

  public GetFibberglassClients() {
    return this.http.get("Lookups/GetFibberglassClients");
  }

  public getMeasurementUnits() {
    return this.http.get("Lookups/GetMeasurementUnits");
  }

  public getPorts() {
    return this.http.get("Lookups/GetPorts");
  }

  public GetShipTypes() {
    return this.http.get("Lookups/GetShipTypes");
  }

  public GetPropellerTypes() {
    return this.http.get("Lookups/GetPropellerTypes");
  }

  public GetMilitaryShipmentTypes() {
    return this.http.get("Lookups/GetMilitaryShipmentTypes");
  }

  public GetShipmentTypes() {
    return this.http.get("Lookups/GetShipmentTypes");
  }

  public GetNationality() {
    return this.http.get("Lookups/GetNationalities");
  }

  public GetConfiguration() {
    return this.http.get("Lookups/GetConfigurations");
  }
  public GetFuelTypes() {
    return this.http.get("Lookups/GetFuelTypes");
  }

  public getSailDirections() {

    return this.http.get("Lookups/GetSailDirections");
  }

  public GetFloatingCranesNames() {
    return this.http.get("Lookups/GetFloatingCranesNames");
  }

  public GetFloatingCranesTypes() {
    return this.http.get("Lookups/GetFloatingCranesTypes");
  }

  public getRates() {
    return this.http.get("Lookups/GetRates");
  }

  public getTugs() {
    return this.http.get("Lookups/GetTugs");
  }

  public getSupplierBidSubsriptionTypes() {
    return this.http.get("Lookups/GetSupplierBidSubsriptionTypes");
  }
  public GetSecurityLevel() {
    return this.http.get("Lookups/GetSecurityLevel");
  }

  public getMainEngineFuels() {
    return this.http.get("Lookups/GetMainEngineFuels");
  }

  //#region ETender Supplier Registration
  public getAllSupplierRegistrationLookups() {
    return this.http.get("Lookups/GetAllSupplierRegistrationLookups");
  }
  public getSupplierNatures() {
    return this.http.get("Lookups/GetSupplierNatures");
  }
  public getSupplierTypes() {
    return this.http.get("Lookups/GetSupplierTypes");
  }
  public getContractorCategories() {
    return this.http.get("Lookups/GetContractorCategories");
  }
  public getContractorClassification() {
    return this.http.get("Lookups/GetContractorClassification");
  }
  public getSpecialities() {
    return this.http.get("Lookups/GetSpecialities");
  }
  public getSupplierAccountStatuses() {
    return this.http.get("Lookups/GetSupplierAccountStatuses");
  }
  //#endregion

  public getTenderLookups() {
    return this.http.get("Lookups/GetTenderLookups");
  }

}
